import React, { Component } from 'react';
import { AvForm, AvField, AvGroup, AvInput, AvFeedback, AvRadioGroup, AvRadio, AvCheckboxGroup, AvCheckbox } from 'availity-reactstrap-validation';
import { Button, Label, FormGroup, CustomInput } from 'reactstrap';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import Header from '../Shared/Header';
import ReactTooltip from "react-tooltip";
import Loader from 'react-loader-spinner'
  
class MultiStepForm extends React.Component {

    AllData = [];

    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            errorMessage: '',
            termofLoanError:'',
            purposeofLoan:'',
            error: false,
            isLoading: false,
            isSubmitting:false,
            responseData:{},
            monthy_payment:0,
            rate:0,
            country:'',
            branches:[],
            telephone: '',
            regexp : /^[0-9\b]+$/,
        }
        // this.branches = [];
        this.handleSubmitStep2 = this.handleSubmitStep2.bind(this);
        this.handleSubmitStep3 = this.handleSubmitStep3.bind(this);
        this.handleSubmitStep4 = this.handleSubmitStep4.bind(this);
        

        this.getstep3Data = this.getstep3Data.bind(this);
        // console.log("dsfsff",);
    }
    nextStep = (value) => {
        this.setState({
            step : value
        })
        if(value == 2){
            this.getCountry();
        }else if(value == 3){
            this.getstep3Data()
        }else if(value == 4){
            this.getstep4Data()
        }
        window.sessionStorage.setItem("step", value);
        localStorage.setItem('step',value);
    }

    handleChange = input => event => {
        this.setState({ [input] : event.target.value })
    }

    componentWillMount() {
        // let step = JSON.parse(localStorage.getItem('step'));
        let step = JSON.parse(window.sessionStorage.getItem("step"))
        if(step){
            if(step == 2){
                this.getstep3Data()
                this.getCountry();
            }else if(step == 3){
                this.getstep3Data()
            }else if(step == 4){
                this.getstep4Data()
            }
        }
        if(step){
            // console.log("my new step ",step)
            this.setState({
                step : step,
                isLoading: false
            })
        }else{
            this.setState({
                step : 1,
                isLoading: false
            })
        }
    }

    getCountry(){
        let branches = [
            { value: 'Roseau', name: 'Roseau' }          
        ];
        this.setState({branches:branches});
        axios.get(API_BASE_URL + '/get_country')
        .then((response) => {
            this.setState({country:response.data.country})
            const country = response.data.country;
        });
    }

    getstep3Data(){
        this.setState({
            isLoading : true
        })
        const id = JSON.parse(window.sessionStorage.getItem("last_inserted_id"))
        //  JSON.parse(localStorage.getItem('last_inserted_id'));
        if(id){
            axios.get(API_BASE_URL + '/getdata/'+id)
            .then((response) => {
                this.setState(
                    {responseData: response.data.data,isLoading:false},
                ); 
            });
        }
    }
    
    getstep4Data(){
        this.setState({
            isLoading : true
        })
        const id =  JSON.parse(window.sessionStorage.getItem("last_inserted_id"))
        axios.get(API_BASE_URL + '/getmarketo_data/'+id)
        .then((response) => {
            this.setState({responseData: response.data.data,isLoading:false}); 
        });
    }


    gotoHome(){
        this.setState({step : 1})
        window.sessionStorage.setItem("step", 1);
    }

    
    handleSubmitStep2(event, values){
        this.setState({values});
        const country = this.state.country;
        const step2 = {
            rBLBankingFacilities:  this.state.values.rBLBankingFacilities,
            lPFirstName: this.state.values.lPFirstName,
            lPLastName: this.state.values.lPLastName,
            ageRange: this.state.values.ageRange,
            preferredBranch: this.state.values.preferredBranch,
            email: this.state.values.email,
            lPMobileNumber: this.state.values.lPMobileNumber,
            calltime: this.state.values.calltime,
            Country:country
        }
        this.setState({
            isLoading : true,
            isSubmitting:true,
            errorMessage: ''
        })

        if( JSON.parse(window.sessionStorage.getItem("last_inserted_id"))){
            step2.id = JSON.parse(window.sessionStorage.getItem("last_inserted_id"));
            axios.post(API_BASE_URL + '/update_step2', step2)
            .then((response) => {
                // localStorage.setItem('step',3);
                window.sessionStorage.setItem("step", 3);
                window.sessionStorage.setItem("last_inserted_id", response.data.last_insert_id);
                localStorage.setItem('last_inserted_id',response.data.last_insert_id);
                // localStorage.setItem('step2_data',response.data.data);
                this.setState({
                    step : 3,
                    isLoading : false,
                    isSubmitting:false,
                    responseData: response.data.data
                })      
            })
            .catch((error) => {
                // Error
                if (error.response) {
                    this.setState({
                        errorMessage : error.response.data.message,
                        isLoading : false,
                        isSubmitting:false
                    })
                    console.log("errrrrrrr",error.response);
                }
            });
        }else{
            axios.post(API_BASE_URL + '/save_step2', step2)
            .then((response) => {
                // localStorage.setItem('step',3);
                window.sessionStorage.setItem("step", 3);
                window.sessionStorage.setItem("last_inserted_id", response.data.last_insert_id);
                localStorage.setItem('last_inserted_id',response.data.last_insert_id);
                // localStorage.setItem('step2_data',response.data.data);
                this.setState({
                    step : 3,
                    isLoading : false,
                    isSubmitting:false,
                    responseData: response.data.data
                })      
            })
            .catch((error) => {
                // Error
                if (error.response) {
                    this.setState({
                        errorMessage : error.response.data.message,
                        isLoading : false,
                        isSubmitting:false
                    })
                    console.log("errrrrrrr",error.response);
                }
            });
        }

    }

    purposeofLoanChange(event){
        this.setState({purposeofLoan: event.target.value});
    }

    handleSubmitStep3(event, values){

        let lastInsertedData = this.state.responseData;

        if((values.purposeofLoan == 'Purchase a Car' || values.purposeofLoan == 'Other') && values.termofLoan > 7 ){
            this.setState({ termofLoanError : 'Term of Loan cannot be more than 7 years'});
            return false;
        }else{
            this.setState({ termofLoanError : ''});
        }

        if((values.purposeofLoan == 'Own a home' || values.purposeofLoan == 'Property Secured Loan')  && values.termofLoan > 30 ){
            this.setState({ termofLoanError : 'Term of Loan cannot be more than 30 years'});
            return false;
        }else{
            this.setState({ termofLoanError : ''});
        }

        let rate = 0;
        let Monthly_Payment = 0;
        let cc_monthlyPayment = 0;
        let loanStatus = 'Fail';
        let Totaldebt = 0;
        let totaldebt_status = 'Fail'; 

         /* Calculate Monthly Payment */
        if(values.purposeofLoan == 'Purchase a Car' || values.purposeofLoan == 'Property Secured Loan' || values.purposeofLoan == 'Own a home' || values.purposeofLoan == 'Other' ){
            if(values.purposeofLoan == 'Purchase a Car'){
                rate = 6.8;
            }else if(values.purposeofLoan == 'Own a home' || values.purposeofLoan == 'Property Secured Loan'){
                rate = 6;
            }else if(values.purposeofLoan == 'Other'){
                rate = 10;
            }
            const Months = values.termofLoan * 12;
            rate = rate/100;
            Monthly_Payment = values.loanValue * (rate / 12) * Math.pow((1 + rate / 12), Months) / (Math.pow((1 + rate / 12), Months) - 1)
    
        }
        
        /* Calculate CC Monthly Payment */
        if(values.purposeofLoan == 'Apply for a credit card'){
            if(lastInsertedData.existing_customer == 1){
                cc_monthlyPayment = values.loanValue/36;
            }else{
                cc_monthlyPayment = values.loanValue/24;
            }
        }

        /* Calculate DSR  */
        let additionalIncome = Number(values.additionalIncome)
        let DSR = 0
        if(values.purposeofLoan == 'Apply for a credit card'){
            DSR = ((Number(values.monthlyLoanAmount) + Number((cc_monthlyPayment).toFixed()) + Number(values.rent)) / (Number(values.salary) + (additionalIncome * 0.50))) * 100;
        }else{
            DSR = ((Number(values.monthlyLoanAmount) + Number((Monthly_Payment).toFixed()) + Number(values.rent)) / (Number(values.salary) + (additionalIncome * 0.50))) * 100;
        }

        if(Number((DSR).toFixed()) < 40){
            loanStatus = "Success";
        }

        /* Calculate Total debt  */
        Totaldebt = Number(values.debtBalance) + Number(values.loanValue) 
        if(Totaldebt < values.salary * 10){
            totaldebt_status = "Success";
        }


        this.setState({ isLoading: true, isSubmitting:true, errorMessage: '' });
        const last_inserted_id = JSON.parse(window.sessionStorage.getItem("last_inserted_id"))
        const step3 = {
            employer:  values.employer,
            lengthofEmployment: values.lengthofEmployment,
            employmentStatus: values.employmentStatus,
            salary: values.salary,
            isaHomeowner: values.isaHomeowner,
            additionalIncome: values.additionalIncome,
            monthlyLoanAmount: values.monthlyLoanAmount,
            rent: values.rent,
            debtBalance: values.debtBalance,
            purposeofLoan: values.purposeofLoan,
            loanValue:values.loanValue,
            termofLoan:values.termofLoan,
            inserted_id:last_inserted_id,
            rate:rate,
            DSR:DSR,
            Monthly_Payment:Monthly_Payment,
            cc_monthlyPayment:cc_monthlyPayment,
            loanStatus:loanStatus,
            Totaldebt:Totaldebt,
            totaldebt_status:totaldebt_status,
            mIHOtherPurpose:values.mIHOtherPurpose
        }

        if(this.state.responseData.step3table){
            axios.post(API_BASE_URL + '/update_step3', step3)
            .then((response) =>{
                window.sessionStorage.setItem("step", 4);
                this.setState({
                    step : 4,
                    isLoading : false,
                    isSubmitting:false,
                    responseData: response.data.data
                })
            })
            .catch((error) => {
                // Error
                if (error.response) {
                    this.setState({
                        errorMessage : error.response.data.message,
                        isLoading : false,
                        isSubmitting:false
                    })
                    console.log("errrrrrrr",error.response);
                }
            });
        }else{
            axios.post(API_BASE_URL + '/save_step3', step3)
            .then((response) =>{
                window.sessionStorage.setItem("step", 4);
                this.setState({
                    step : 4,
                    isLoading : false,
                    isSubmitting:false,
                    responseData: response.data.data
                })
            })
            .catch((error) => {
                // Error
                if (error.response) {
                    this.setState({
                        errorMessage : error.response.data.message,
                        isLoading : false,
                        isSubmitting:false
                    })
                    console.log("errrrrrrr",error.response);
                }
            });
        }
    }

    handleSubmitStep4(event, values){
        let marketoData = {
            rBLBankingFacilities:this.state.responseData.existing_customer,
            lPFirstName:this.state.responseData.first_name,
            lPLastName:this.state.responseData.last_name,
            ageRange:this.state.responseData.age,
            preferredBranch:this.state.responseData.branch,
            Email:this.state.responseData.email,
            lPMobileNumber:this.state.responseData.primary_phonenumber,
            calltime:this.state.responseData.call_time,
            employer:this.state.responseData.step3table.employer,
            lengthofEmployment:this.state.responseData.step3table.lengthofEmployment,
            employmentStatus:this.state.responseData.step3table.employmentStatus,
            salary:this.state.responseData.step3table.salary,
            isaHomeowner:this.state.responseData.step3table.isaHomeowner,
            additionalIncome:this.state.responseData.step3table.additionalIncome,
            monthlyLoanAmount:this.state.responseData.step3table.monthlyLoanAmount,
            rent:this.state.responseData.step3table.rent,
            debtBalance:this.state.responseData.step3table.debtBalance,
            purposeofLoan:this.state.responseData.step3table.purposeofLoan,
            loanValue:this.state.responseData.step3table.loanValue,
            termofLoan:this.state.responseData.step3table.termofLoan,
            termsAgreementMIH:1,
            DSR:this.state.responseData.step3table.DSR,
            totalDebt:this.state.responseData.step3table.Totaldebt,
            monthlyPayment:this.state.responseData.step3table.Monthly_Payment,
            loanStatus:this.state.responseData.step3table.loanStatus,
            Country:this.state.responseData.Country,
            mIHLatestFormSubmitted:this.state.responseData.step3table.created_at,
            cCMonthlyPayment:this.state.responseData.step3table.cc_monthlyPayment,
            totalDebtStatus:this.state.responseData.step3table.totaldebt_status,
            mIHOtherPurpose:this.state.responseData.step3table.mIHOtherPurpose,
            programCampaign:'RBEC MIH Application',
            utmcampaign:'',
            utmcontent:'',
            utmmedium:'',
            utmsource:''
        }

        this.setState({ isLoading: true, isSubmitting:true, errorMessage: '' });
        const headers = {
            "Content-Type": "application/json"
        }
        axios.post(API_BASE_URL + '/saveMarketo', marketoData,headers)
        .then((response) =>{
            window.sessionStorage.removeItem('last_inserted_id');
            window.sessionStorage.setItem("step", 5);
            this.setState({
                step : 5,
                isLoading : false,
                isSubmitting:false,
                responseData: response.data.data
            })
        })
        .catch((error) => {
            // Error
            if (error.response) {
                this.setState({
                    errorMessage : error.response.data.message,
                    isLoading : false,
                    isSubmitting:false
                })
                console.log("errrrrrrr",error.response);
            }
        });
    }


    handleBackClick(page){
        if(page == 2){
            this.getCountry();
            this.getstep3Data();
            window.sessionStorage.setItem("step", 2);
            this.setState({
                step : page
            })
        }else if(page == 3){
            this.getstep4Data();
            window.sessionStorage.setItem("step", 3);
            this.setState({
                step : page
            })
        }
    }


    render(){
        const {step} = this.state;
        const defaultValuesStep2 = {
            rBLBankingFacilities: '0',
        };

        const defaultValues = {
            preferredBranch:"Roseau"
        };

        var existingCustomer ;
        if(this.state.responseData){
            if(this.state.responseData.existing_customer == 1){
                existingCustomer = '1'
            }else if(this.state.responseData.existing_customer == 0){
                existingCustomer = '0'
            }
        }


      switch(step) {
      case 1:
          return (
            <>
            <Header/>
            <section className="home-screen flex-full d-none1">
                <div className="container flex-full">
                    <div className="home-screen-content flex-full">
                        <div className="home-screen-text flex-full">
                            <h1>You’re one step closer to doing what you’ve planned, let’s help you get there!</h1>
                            <input type="button" className="btn"  onClick={() => this.nextStep(2)}  value="Get Started"/>
                            {/* onClick={() => this.renderRedirect} */}
                            {/* <Router>
                            <Link className="btn" onClick={this.saveAndContinue}>Get Started</Link>
                            </Router> */}
                        </div>
                    </div>
                </div>
            </section>
            </>
        )
      case 2:
        return (
        <>
        { this.state.isLoading ?    
            <div className="pre-loader">
                <Loader type="Puff" color="#008ec2" height={100} width={100}   />
            </div> : null 
        }
        <Header/>
            <section className="form-screen form-screen1 flex-full">
            <div className="container">
                <div className="form-banner flex-full">                        
                    <div className="form-banner-content flex-full">
                        <h2>Tell us about yourself, getting to know you better will help us understand what you want to achieve.</h2>
                    </div>
                </div>
                <div className="progress-bar-section flex-full">
                    <div className="pc-12 completed-area"><span>12%</span></div>
                </div>
                <div className="form-main-section flex-full">
                    <figure className="form-screen-image"><img src={require('../../images/form-screen1.jpg')} alt="Form screen 1"/></figure>
                    <div className="form-main-content">
                        <h2>Let's begin.</h2>
                        <AvForm onValidSubmit={this.handleSubmitStep2} model={defaultValues}  className="application-form">
                            <div className="existing-customer">
                                <label className="form-label">Are you an existing Republic Bank customer?</label>
                                <div className="radio-grp">
                                    <AvRadioGroup name="rBLBankingFacilities"  value={existingCustomer} validate={{required: {value: true, errorMessage: 'This is a required field'}}}>
                                        <AvRadio label="Yes" value="1" />
                                        <AvRadio  label="No" value="0" />
                                    </AvRadioGroup>
                                  {/* <input type="radio" name="existing-customer" id="yes" />
                                  <label htmlFor="yes">Yes</label>
                                  <input type="radio" name="existing-customer" id="no"/> */}
                                  {/* <label htmlFor="no">No</label> */}
                                </div>
                            </div>
                            <div className="seperator"></div>
                            <div className="name-info">
                                <h3>Hello my name is :</h3>
                                <div className="name-info-row">
                                    <div className="name-info-col">
                                        <label className="form-label">First</label>
                                        <AvField  type="text" name="lPFirstName" value={this.state.responseData ? this.state.responseData.first_name : ""} className="input-grp" placeholder="James" validate={{required: {value: true, errorMessage: 'This is a required field'}}} />                                        
                                    </div>
                                    <div className="name-info-col">
                                        <label className="form-label">Last</label>
                                        <AvField  type="text" name="lPLastName" value={this.state.responseData ? this.state.responseData.last_name: ""} className="input-grp" placeholder="Brown" validate={{required: {value: true, errorMessage: 'This is a required field'}}}  />                                        
                                    </div>
                                </div>
                                <div className="name-info-row">
                                    <div className="name-info-col">
                                        <label className="form-label">I am</label>
                                        <AvField type="select" name="ageRange" value={this.state.responseData ? this.state.responseData.age : ""} className="input-grp" validate={{required: {value: true, errorMessage: 'This is a required field'}}}>
                                            <option>Select</option>
                                            <option>Under 18</option>
                                            <option>18-24</option>
                                            <option>25-34</option>
                                            <option>35-44</option>
                                            <option>45-65</option>
                                            <option>55-65</option>
                                            <option>Over 65</option>
                                        </AvField>
                                    </div>
                                    <div className="name-info-col">
                                        <label className="form-label">Branch</label>
                                        <AvField  type="select" name="preferredBranch"  value={this.state.responseData ? this.state.responseData.branch : ''} className="input-grp" validate={{required: {value: true, errorMessage: 'This is a required field'}}}>
                                                {this.state.branches.map((e, key) => {
                                                    return <option key={key} value={e.value}>{e.name}</option>;
                                                })}
                                            {/* <option>Option 1</option>
                                            <option>Option 2</option>
                                            <option>Option 3</option> */}
                                        </AvField>
                                    </div>
                                </div>
                            </div>
                            <div className="seperator"></div>
                            <div className="contact-info">
                                <div className="contact-info-row">
                                  <div className="contact-info-col">
                                      <label className="form-label">My email address is</label> 
                                      <AvField type="text" name="email" value={this.state.responseData ? this.state.responseData.email: ''} className="input-grp" placeholder="james@email.com" validate={{
                                        required: {value: true, errorMessage: 'This is a required field'},
                                        pattern: {value: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,  errorMessage: 'Please enter valid email'
                                        }}}  />
                                  </div>
                              </div>
                              <div className="contact-info-row">
                                  <div className="contact-info-col">
                                      <label className="form-label">You can reach me at</label>
                                      {/* validate={{tel: true,required: {value: true, errorMessage: 'This is a required field'}}} */}
                                      <AvField type="text" value={this.state.responseData ? this.state.responseData.primary_phonenumber: ''}  name="lPMobileNumber" validate={{number: true,required: {value: true, errorMessage: 'This is a required field'},maxLength: {value: 7}}}  className="input-grp"  placeholder="Primary Number" />
                                      <AvField type="text" value={this.state.responseData ? this.state.responseData.secondary_phonenumber:''}  name="secondary-number" validate={{number: true,maxLength: {value: 7}}} className="input-grp" placeholder="Secondary Number" />
                                  </div>
                              </div>
                              <div className="contact-info-row">
                                  <div className="contact-info-col">                                      
                                      <label className="form-label">Best time to call me</label>
                                      <AvField type="select" value={this.state.responseData ? this.state.responseData.call_time:''} name="calltime" className="input-grp">
                                          <option>Select</option>
                                          <option>AM</option>
                                          <option>PM</option>
                                      </AvField>
                                      {/* <span className="help-icon" title="We’re excited to chat with you, so don’t forget to tell us what’s the best time to give you a call."><i>?</i></span> */}
                                      <span className="help-icon" data-tip="We’re excited to chat with you, so don’t forget to tell us what’s the best time to give you a call."><i>?</i></span>
                                      <ReactTooltip place="right" type="dark" effect="solid" />                                      
                                  </div>
                              </div>
                          </div>
                          <div className="submit-btn-wrapper">
                          <FormGroup>
                            <Button>Keep Going</Button>
                          </FormGroup>
                          { this.state.errorMessage && <div className="invalid-feedback"> { this.state.errorMessage } </div> }
                              {/* <input type="submit" className="btn" onClick={this.nextStep} value="Keep going"/> */}
                          </div>
                      </AvForm>
                      
                  </div>
              </div>
          </div>
          </section>
          </>
      );
      case 3:
        return (
            <>
        { this.state.isLoading ?    
            <div className="pre-loader">
                <Loader type="Puff" color="#008ec2" height={100} width={100}   />
            </div> : null 
        }
        <Header/>
          <section className="form-screen form-screen2 flex-full">
          <div className="container">
              <div className="form-banner flex-full">                    
                  <div className="form-banner-content flex-full">
                      <h2>Let’s talk numbers and Make it Happen!</h2>
                      <p>Did you know that with a Make It Happen Loan, you can achieve almost any personal goal you’ve set? We’ll tell you some more when we connect but for now let’s crunch some numbers! We’re eager to find out what you want to achieve and how we can help!</p>
                  </div>
              </div>
              <div className="progress-bar-section flex-full">
                  <div className="pc-40 completed-area"><span>40%</span></div>
              </div>
              <div className="form-main-section flex-full">
                  <figure className="form-screen-image"><img src={require('../../images/form-screen2.jpg')} alt="Form screen 2"/></figure>
                  <div className="form-main-content">
                    <AvForm onValidSubmit={this.handleSubmitStep3} className="application-form">
                          <div className="employment-info">
                              <div className="employment-row">
                                  <div className="employment-col">
                                      <label className="form-label">I am employed at</label> 
                                      <AvField  type="text" name="employer" value={this.state.responseData.step3table ? this.state.responseData.step3table.employer : ""} className="input-grp" placeholder=""  validate={{required: {value: true, errorMessage: 'This is a required field'}}} />
                                  </div>
                              </div>                                
                              <div className="employment-row">
                                  <div className="employment-col">
                                      <label className="form-label">I’ve worked there for</label>
                                      <AvField  type="text" value={this.state.responseData.step3table ? this.state.responseData.step3table.lengthofEmployment : ""} validate={{number: true,required: {value: true, errorMessage: 'This is a required field'},minLength: {value: 1}, maxLength: {value: 2}}} name="lengthofEmployment" className="input-grp" placeholder="Number of Years"  required />
                                      {/* <AvField type="select"  name="lengthofEmployment" className="input-grp" required>
                                          <option>Select</option>
                                          <option>Option 1</option>
                                          <option>Option 2</option>
                                          <option>Option 3</option>
                                      </AvField> */}
                                  </div>
                              </div>
                              <div className="employment-row">
                                  <div className="employment-col">
                                      <label className="form-label">Employment Status</label>
                                      <AvField type="select" name="employmentStatus" value={this.state.responseData.step3table ? this.state.responseData.step3table.employmentStatus : ""} className="input-grp" validate={{required: {value: true, errorMessage: 'This is a required field'}}}>
                                          <option>Select</option>
                                          <option>Permanent</option>
                                          <option>Temporary/Contract</option>
                                          <option>Commissioned</option>
                                          <option>Unemployed</option>
                                      </AvField>
                                  </div>
                              </div>
                              <div className="employment-row">
                                  <div className="employment-col">
                                      <label className="form-label">My monthly salary is</label>
                                      <AvField  type="text" value={this.state.responseData.step3table ? this.state.responseData.step3table.salary : ""} validate={{number: true,required: {value: true, errorMessage: 'This is a required field'},minLength: {value: 1}, maxLength: {value: 6}}} name="salary" className="input-grp" placeholder="Monthly Amount" required />
                                      {/* <AvField type="select" name="salary" className="input-grp" required>
                                          <option>Select</option>
                                          <option>Option 1</option>
                                          <option>Option 2</option>
                                          <option>Option 3</option>
                                      </AvField> */}
                                  </div>
                              </div>
                            <div className="employment-row">
                                <div className="employment-col">
                                    <label className="form-label">My commission or extra income is</label> 
                                    <AvField type="text" value={this.state.responseData.step3table ? this.state.responseData.step3table.additionalIncome : ""}  validate={{number: true,required: {value: true, errorMessage: 'This is a required field'}}} name="additionalIncome" className="input-grp" placeholder="Monthly Amount"/>
                                    <span className="help-icon" data-tip="Place 0.00 in this box if your salary is commission based and already included in salary field above"><i>?</i></span>
                                      <ReactTooltip place="right" type="dark" effect="solid" />
                                </div>
                            </div>
                              <div className="employment-row">
                                  <div className="employment-col">
                                      <label className="form-label">I am a homeowner</label>
                                      <AvField type="select" name="isaHomeowner" value={this.state.responseData.step3table ? this.state.responseData.step3table.isaHomeowner : ""}  className="input-grp" validate={{required: {value: true, errorMessage: 'This is a required field'}}}>
                                          <option>Select</option>
                                          <option value="1">Yes</option>
                                          <option value="0">No</option>
                                      </AvField>
                                  </div>
                              </div>
                          </div>
                          <div className="seperator"></div>
                          <div className="income-info">
                              <div className="income-row">
                                  <div className="income-col">
                                      <label className="form-label">I pay this amount in loans monthly</label> 
                                      <AvField type="text" value={this.state.responseData.step3table ? this.state.responseData.step3table.monthlyLoanAmount : ""}   validate={{number: true,required: {value: true, errorMessage: 'This is a required field'}}} name="monthlyLoanAmount" className="input-grp" placeholder="Monthly Amount" required />
                                      {/* <span className="help-icon" title="This is the total amount you pay monthly toward ALL your loans at Banks, Credit Unions and other institutions"><i>?</i></span> */}                                      
                                      <span className="help-icon" data-tip="This is the total amount you pay monthly toward ALL your loans at Banks, Credit Unions and other institutions"><i>?</i></span>
                                      <ReactTooltip place="right" type="dark" effect="solid" />
                                  </div>
                              </div>
                              <div className="income-row">
                                  <div className="income-col">
                                      <label className="form-label">My rent is</label> 
                                      <AvField type="text" value={this.state.responseData.step3table ? this.state.responseData.step3table.rent : ""}   validate={{number: true,required: {value: true, errorMessage: 'This is a required field'}}} name="rent" className="input-grp" placeholder="Monthly Amount" required />                                        
                                  </div>
                              </div>
                              <div className="income-row">
                                  <div className="income-col">
                                      <label className="form-label">My loan balances total</label> 
                                      <AvField type="text"  value={this.state.responseData.step3table ? this.state.responseData.step3table.debtBalance : ""}  validate={{number: true,required: {value: true, errorMessage: 'This is a required field'}}} name="debtBalance" className="input-grp" placeholder="Total Amount" required/>
                                      {/* <span className="help-icon" title="This is the total outstanding balance on your loans at Banks, Credit Unions and other institutions"><i>?</i></span> */}
                                      <span className="help-icon" data-tip="This is the total outstanding balance on your loans at Banks, Credit Unions and other institutions. Your closest approximation is acceptable."><i>?</i></span>
                                      <ReactTooltip place="right" type="dark" effect="solid" />
                                  </div>
                              </div>
                          </div>
                          <div className="seperator"></div>
                          <div className="loan-info">
                              <div className="loan-row">
                                  <div className="loan-col">
                                      <label className="form-label">I'd like to</label> 
                                      <AvField type="select"   name="purposeofLoan" onChange={this.purposeofLoanChange.bind(this)} value={this.state.responseData.step3table ? this.state.responseData.step3table.purposeofLoan: this.state.purposeofLoan} className="input-grp" validate={{required: {value: true, errorMessage: 'This is a required field'}}}>
                                          <option>Select</option>
                                          <option value="Purchase a Car">Purchase a Car</option>
                                          <option value="Own a home">Own a home</option>
                                          <option value="Apply for a credit card">Apply for a credit card</option>
                                          <option value="Property Secured Loan">Property Secured Loan</option>
                                          <option value="Apply for Build Easy Loan">Apply for Build Easy Loan</option>
                                          <option value="Other">Other</option>
                                      </AvField>
                                      {/* <span className="help-icon" title="Credit cards are issued in US Dollars and the EC amount requested on this form will be converted to USD if approved"><i>?</i></span> */}
                                      <span className="help-icon" data-tip="Property Secured Loans can be used for debt consolidation, medical, educational and other purposes."><i>?</i></span>
                                      <ReactTooltip place="right" type="dark" effect="solid" />
                                  </div>
                              </div>
                              { this.state.purposeofLoan == 'Other' &&
                              <div className="loan-row">
                                  <div className="loan-col">
                                      <label className="form-label">Other Purpose</label> 
                                      <AvField type="text" value={this.state.responseData.step3table ? this.state.responseData.step3table.mIHOtherPurpose : ""}  name="mIHOtherPurpose"  validate={{required: {value: true, errorMessage: 'This is a required field'}}} className="input-grp" placeholder="Other Purpose" required />                                        
                                 </div>
                              </div>    
                                }    
                              <div className="loan-row">
                                  <div className="loan-col">
                                      <label className="form-label">My request is for $</label> 
                                      <AvField type="text" value={this.state.responseData.step3table ? this.state.responseData.step3table.loanValue : ""}  validate={{number: true,required: {value: true, errorMessage: 'This is a required field'}}} name="loanValue" className="input-grp" placeholder="Loan Amount or Credit Card Limit" required />                                        
                                  </div>
                              </div>
                              { this.state.purposeofLoan != 'Apply for a credit card' &&
                              <div className="loan-row">
                                  <div className="loan-col">
                                      <label className="form-label">I want to repay in</label> 
                                      <AvField type="text" value={this.state.responseData.step3table ? this.state.responseData.step3table.termofLoan : ""}  name="termofLoan"  validate={{number: true,required: {value: true, errorMessage: 'This is a required field'}}} className="input-grp" placeholder="Number of Years" required />                                        
                                      { this.state.termofLoanError && <div className="invalid-feedback"> { this.state.termofLoanError } </div> }
                                 </div>
                              </div>    
                                } 
                                                    
                          </div>
                          <div className="submit-btn-wrapper">
                          <FormGroup>
                            <button type="button" className="btn btn-secondary" onClick={() => this.handleBackClick(2)}>Back</button>
                            <Button>Get me closer to my dream</Button>
                          </FormGroup>
                          { this.state.errorMessage && <div className="invalid-feedback"> { this.state.errorMessage } </div> }
                              {/* <input type="submit" className="btn"  onClick={this.nextStep} value="Get me closer to my dream"/> */}
                          </div>
                      </AvForm>
                      
                  </div>
              </div>
          </div>
      </section>
      </>
      );
    case 4:
        return (
            <>
            { this.state.isLoading ?    
                <div className="pre-loader">
                    <Loader type="Puff" color="#008ec2" height={100} width={100}   />
                </div> : null 
            }
            <Header/>
            <section className="form-screen form-screen3 flex-full">
            <div className="container">
                <div className="form-banner flex-full">                    
                    <div className="form-banner-content flex-full">
                        <h2>Before we can get to work please confirm the following:</h2>                            
                    </div>
                </div>
                <div className="progress-bar-section flex-full">
                    <div className="pc-70 completed-area"><span>70%</span></div>
                </div>
                <div className="form-main-section flex-full">
                    <figure className="form-screen-image"><img src={require('../../images/form-screen3.jpg')} alt="Form screen 3"/></figure>
                    <div className="form-main-content">
                        <AvForm onValidSubmit={this.handleSubmitStep4} className="application-form">
                            <div className="agreement-info">
                                <p>”I confirm that all statements made herein are true and correct and have been made by me knowing you will rely upon such statements in considering this application for any banking facilities you may offer. I authorise Republic Bank (EC) Limited and any of its subsidiaries to obtain information on my/our credit history from any source including credit rating agencies and financial institutions. All sources are hereby authorised to provide any requested information to Republic Bank (EC) Limited and any of it subsidiaries.”</p>
                                <p>I hereby further confirm that my use of this electronic facility, constitutes my acceptance of Republic Bank (EC) Limited’s Terms of Use, Privacy Policy and associated disclaimers, and my agreement to be bound by them.</p>
                                <p><strong>I agree to the above terms</strong></p>
                                <div className="checkbox-grp flex-main">
                                <AvCheckboxGroup name="termsAgreementMIH" label="" validate={{required: {value: true, errorMessage: 'This is a required field'}}}>
                                    <AvCheckbox label="Yes" value="1" />
                                </AvCheckboxGroup>
                                    {/* <input type="checkbox" name="agree" id="agree" />
                                    <label htmlFor="agree">Yes</label> */}
                                </div>
                            </div>
                            <div className="submit-btn-wrapper">
                            <FormGroup>
                                <button  type="button" className="btn btn-secondary" onClick={() => this.handleBackClick(3)}>Back</button>
                                <Button>Submit</Button>
                            </FormGroup>
                                {/* <input type="submit" className="btn"  onClick={this.nextStep}  value="Submit"/> */}
                            </div>
                        </AvForm>
                        
                    </div>
                </div>
            </div>
        </section>
        </>
      )
      case 5:
        return (
            <>
            <Header/>
            <section className="form-screen thankyou-screen flex-full">
                <div className="container">
                    <div className="thankyou-banner flex-full">
                        <figure><img src={require('../../images/thankyou-screen.jpg')} alt="Thank you screen"/></figure>
                    </div>
                    <div className="progress-bar-section flex-full">
                        <div className="pc-100 completed-area"><span>100%</span></div>
                    </div>
                    <div className="form-banner flex-full">                    
                        <div className="form-banner-content flex-full">
                            <h2 className="big">Thank you for your application.</h2>
                            <h2>You’re now even closer to doing some of the things you’ve been dreaming of.</h2>
                            <p><strong>Congrats!</strong> Your application has been automatically assessed and a preliminary response was sent via email. Check your inbox now!</p>
                            <div className="submit-btn-wrapper">                            
                            <FormGroup>
                                <button  type="button" onClick={() => this.gotoHome()} className="btn btn-secondary">Return to Homepage</button>                                
                            </FormGroup>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </>
        )
    }
  }
}

export default MultiStepForm;